let SlideInPosition = /*#__PURE__*/function (SlideInPosition) {
  SlideInPosition["TOP"] = "top";
  SlideInPosition["RIGHT"] = "right";
  SlideInPosition["BOTTOM"] = "bottom";
  SlideInPosition["LEFT"] = "left";
  return SlideInPosition;
}({});

export { SlideInPosition };
//# sourceMappingURL=position.js.map
